import related_image1 from "../../images/latest-outfit1.png";
import related_image2 from "../../images/latest-outfit2.png";
import related_image3 from "../../images/latest-outfit3.png";
import related_image4 from "../../images/latest-outfit4.png";

const Items = [
    {id: 1, image: related_image1, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
    {id: 2, image: related_image2, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
    {id: 3, image: related_image3, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
    {id: 4, image: related_image4, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
]
export default Items